import Router from 'next/router';

import axios from 'axios';

import { getURl } from './fetch';
import { ServicesURL } from '../ts/enums/fetch-enums';

function getGoogleAnalyticsData() {
  let gaClientId = null;
  if ((window as any)?.gaGlobal?.vid) {
    gaClientId = (window as any)?.gaGlobal?.vid;
  }

	// Use your own ID here ↓
	const pattern = /_ga_YL10D93TYS=GS\d\.\d\.(.+?)(?:;|$)/;
	const match = document.cookie.match(pattern);
	const parts = match?.[1].split(".");

	if (!parts) {
		return;
	}

	return {
    ga_client_id: gaClientId,
		ga_session_id: parts.shift(),
		ga_session_number: parts.shift(),
	};
}

const customAxios = axios.create({
  baseURL: getURl(ServicesURL.CRYPTOCRONTROL),
});

customAxios.interceptors.request.use((config) => {
  const gaData = getGoogleAnalyticsData();

  if (gaData) {
    config.headers['ga-client-id'] = gaData.ga_client_id
    config.headers['ga-session-id'] = gaData.ga_session_id;
    config.headers['ga-session-number'] = gaData.ga_session_number;
  }

  return config;
});

customAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const statusCode = error?.response?.status;

    if (statusCode === 401) {
      Router.push('/?logout=true');
    }

    return Promise.reject(error.response);
  }
);

export const setAuthToken = (token: string): void => {
  customAxios.defaults.headers['Authorization'] = `Bearer ${token}`;
};

export default customAxios;
